/**
 * Ενότητες της εκτύπωσης Ζ/Χ ανά κατάστημα (stores.register_report_sections, migration 253) — ΙΔΙΕΣ
 * για Ζ και Χ (απόφαση ιδιοκτήτη 6/10/2026). Ίδιος κανόνας με τον server
 * (backend/utils/registerStaffReport.js): μόνο οι γνωστές, σε σταθερή σειρά, ποτέ κενό — χωρίς
 * ρύθμιση (παλιό backend) μόνο το κλασικό Ζ, όπως πριν.
 */
export const REGISTER_REPORT_SECTIONS = ['classic', 'users', 'staff_actions'] as const;

export type RegisterReportSection = typeof REGISTER_REPORT_SECTIONS[number];

export const DEFAULT_REGISTER_REPORT_SECTIONS: readonly RegisterReportSection[] = ['classic'];

export function normalizeReportSections(raw: unknown): RegisterReportSection[] {
  const list = Array.isArray(raw) ? raw.map(s => String(s).trim()) : [];
  const out = REGISTER_REPORT_SECTIONS.filter(s => list.includes(s));
  return out.length > 0 ? out : [...DEFAULT_REGISTER_REPORT_SECTIONS];
}
